import { DataSource, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutChangeStopCompareItems extends Layout {
    labelRefNoChanges: Label;
    labelReferenceNumbers: Label;
    labelStopComments: Label;
    panelComments: Panel;
    panelRefnos: Panel;
    sourceEdiCompareGroupRefno: DataSource;
    sourceEdiCompareGroupRefnoChanges: DataSource;
    sourceEdiCompareGroupStopNote: DataSource;
    sourceEdiCompareItem: DataSource;
    tableCompareItems: Table;
    tableRefNoCompareChanges: Table;
    tableStopComment: Table;
    tableStopRefNo: Table;
}
